var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroup35(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 134,
    height: 134,
    viewBox: "0 0 134 134",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M91.7925 39.6358V41.722H112.652V39.6358C112.652 38.4842 111.718 37.5496 110.566 37.5496H93.8787C92.7271 37.5496 91.7925 38.4842 91.7925 39.6358Z",
    fill: "#BAE3F9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.3767 29.2046C33.3767 25.7541 36.1848 22.9461 39.6374 22.9461H93.8784C97.3269 22.9461 100.133 25.7541 100.133 29.2046L100.135 33.377H104.307L104.305 29.2046C104.305 23.4509 99.628 18.7737 93.8784 18.7737H39.6353C33.8816 18.7737 29.2043 23.4509 29.2043 29.2026V33.377H33.3788L33.3767 29.2046Z",
    fill: "#BAE3F9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M41.7195 39.6358C41.7195 38.4842 40.7848 37.5496 39.6333 37.5496H22.9458C21.7942 37.5496 20.8596 38.4842 20.8596 39.6358V41.722H41.7195V39.6358Z",
    fill: "#BAE3F9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M58.4133 73.0126H75.1008V60.4976H58.4133V73.0126ZM64.6698 62.5838H68.8401V70.9264H64.6698V62.5838Z",
    fill: "#BAE3F9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M79.2731 41.7219H54.2388V45.0285L59.8861 50.6759C60.2783 51.0681 60.4974 51.598 60.4974 52.1508V56.3253H73.0124V52.155C73.0124 51.6 73.2315 51.0681 73.6237 50.678L79.2731 45.0285V41.7219Z",
    fill: "#BAE3F9"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M82.8365 47.3692L80.137 50.0688H120.133L115.959 45.8943H83.4478C83.4478 46.4471 83.2266 46.977 82.8365 47.3692Z",
    fill: "#BAE3F9"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M77.1848 54.241V56.3251H77.1869C78.3406 56.3251 79.2731 57.2576 79.2731 58.4113V68.8422H123.081V68.8401H127.253V54.241H77.1848Z",
    fill: "#BAE3F9"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M31.2908 109.701L36.3268 114.737H40.8581L43.5555 112.041C45.9922 109.6 49.9664 109.6 52.4072 112.041L55.1026 114.737H59.6338L62.3312 112.041C64.7679 109.6 68.7421 109.6 71.183 112.041L73.8783 114.737H78.4095L81.107 112.041C83.5437 109.6 87.5179 109.6 89.9587 112.041L92.6541 114.737H97.1832L102.223 109.696V85.532H31.2908V109.701ZM47.9803 91.7906C47.9803 90.6369 48.9129 89.7044 50.0665 89.7044H83.4435C84.5972 89.7044 85.5297 90.6369 85.5297 91.7906V104.306C85.5297 105.459 84.5972 106.392 83.4435 106.392H50.0665C48.9129 106.392 47.9803 105.459 47.9803 104.306V91.7906Z",
    fill: "#BAE3F9"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M50.6756 47.3692C50.2834 46.977 50.0665 46.4471 50.0665 45.8943H17.551L13.3787 50.0667H53.3731L50.6756 47.3692Z",
    fill: "#BAE3F9"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M52.1526 93.8767H81.3572V102.219H52.1526V93.8767Z",
    fill: "#BAE3F9"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M79.2731 75.0988C79.2731 76.2524 78.3406 77.1849 77.1869 77.1849H56.327C55.1734 77.1849 54.2408 76.2524 54.2408 75.0988V73.0146H12.5149V114.736H27.1182V83.4456C27.1182 82.2919 28.0508 81.3594 29.2044 81.3594H104.309C105.461 81.3594 106.396 82.2919 106.396 83.4456V114.736H120.995V73.0146H79.2731V75.0988Z",
    fill: "#BAE3F9"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M54.2409 68.8424V58.4114C54.2409 57.2598 55.1734 56.3273 56.325 56.3252V54.239H6.25635V68.8403H10.4287V68.8424H54.2409Z",
    fill: "#BAE3F9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup35);
export default __webpack_public_path__ + "static/media/Group-35.5d8a3a37cbc97d5341b95faea8b2c93e.svg";
export { ForwardRef as ReactComponent };